'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconElectronicChipZoomed, iconElectronicChipZoomedTag } from '@ni/nimble-components/dist/esm/icons/electronic-chip-zoomed';
import { wrap } from '../../utilities/react-wrapper';

export type { IconElectronicChipZoomed };
export { iconElectronicChipZoomedTag };
export const NimbleIconElectronicChipZoomed = wrap(IconElectronicChipZoomed);